<template lang="pug">
  div
    router-link( to="/listings" class='link-big top-margin-10' @click.native="openSearchIn('Boston:Allston')") New in Allston &#x25b7;
    ListingBrowser( :listings='recentListingsAllston' @apt_unit_activated="listingSet => $emit('update:active-listing', listingSet)" )
    router-link( to="/listings" class='link-big' @click.native="openSearchIn('Boston:Brighton')") New in Brighton &#x25b7;
    ListingBrowser( :listings='recentListingsBrighton' @apt_unit_activated="listingSet => $emit('update:active-listing', listingSet)" )
    router-link( to="/listings" class='link-big' @click.native="openSearchIn('Boston:Jamaica Plain')") New in Jamaica Plain &#x25b7;
    ListingBrowser( :listings='recentListingsJP' @apt_unit_activated="listingSet => $emit('update:active-listing', listingSet)" )

    div(class='full-width-accent')
      h1 Find an apartment <span>the right way.</span>
      div(class='flex-container')
        div(class='flex-item')
          h3 <i class="fas fa-users"></i> The Right People
          p.
            Finding the perfect apartment can be a real challenge, but it doesn't have to be.
            Tell us what you're looking for, then relax while an expert arranges a private viewing of 
            the best apartments that suit your needs and your budget.  Let us do the work for you!
          router-link( to="/agents" ) Meet The Agents
        div(class='flex-item')
          h3 <i class='fas fa-desktop'></i> The Right Tools
          p.
            We maintain a database of tens of thousands of apartments, combining shared listings from
            other agencies with our connections to other more exclusive landlords to give our agents the
            most accurate knowledge of what's truly available.
          router-link( to="/contact" ) Contact Us
        div(class='flex-item')
          h3 <i class="far fa-building"></i> The Right Properties
          p.
            Whether you're looking for a low-priced bargain or a luxurious retreat, our extensive relationships
            with Massachusetts' best property management companies allow us to show you just what you're
            looking for with a landlord that is going to take care of you for your entire stay.
          router-link( to="/listings" ) Search

    iframe( id='uprightMapFrame' frameborder="0" allowfullscreen :src="mapURL" ) Your browser does not support this map.
    
    h2(class='link-big') Featured Properties
    router-link( to="/manage/featured" v-if='admin' class='simple-on-light') Edit
    ListingBrowser( :listings='featuredListings' @apt_unit_activated="listingSet => $emit('update:active-listing', listingSet)" )
    
</template>

<script>
import ListingBrowser from './ListingBrowser.vue'
import { searchRentals, getFeaturedListings } from '../api/listings'
import { GOOGLE_MAPS_URL, GOOGLE_HOME_MAPSTRING } from './settings'
import { mapState } from 'vuex'

export default {
  components: {
    ListingBrowser
  },
  metaInfo: {
    title: 'Upright Realty - Boston Apartment Rentals And Real Estate',
    meta: [
      { name: 'description', content: 'Real Estate services for Boston and the surrounding area, specializing in apartment rentals, home sales, and home buying.' }
    ]
  },
  data(){
    return{
      recentListingsAllston: null,
      recentListingsBrighton: null,
      recentListingsJP: null,
      featuredListings: null
      //featuredListingIDs: "136863793,136863056,166017424,164933587,147534470,152294299,99108930",
    }
  },
  methods: {
    openSearchIn(cityString){
      this.$store.commit("updateLocations", cityString);
    }
  },
  computed: {
    ...mapState(['admin']),
    
    mapURL() {
        return GOOGLE_MAPS_URL + "&zoom=14&q=" + GOOGLE_HOME_MAPSTRING;
    }
  },
  async mounted(){
    //const oneMonthAgo = new Date();
    //oneMonthAgo.setDate(oneMonthAgo.getMonth()-1);
    this.$nextTick(() => { //Do I need this to be in nextTick?
      if (this.$route.params.listing){
        searchRentals({listingIDs: this.$route.params.listing})
        .then(({listings/*, totalNumber*/}) => {
          this.$emit('update:active-listing', {listing:listings[0], listings:listings});
        })
        .catch(() => {})
      }
    });

    //this.featuredListings = await getFeaturedListings();
    getFeaturedListings().then(response => { this.featuredListings = response });

    function parameters(location, count){
      return{
        minRent: "1400",
        photosOnly: true,
        sortDirection: "desc", 
        sortName: "updateDate",
        //updatedSince: oneMonthAgo,
        locations: [location],
        //cancelToken: this.cancelToken,
        listingsPerPage: count
      }
    }
    const searchRecent = (location, count, propName) => {
      searchRentals(
        parameters(location, count)
      )
      .then(({listings/*, totalNumber*/}) => {
        this[propName] = listings ? listings : [];
      })
      .catch(() => {})
    }
    searchRecent("Boston:Allston", 3, "recentListingsAllston");
    searchRecent("Boston:Brighton", 3, "recentListingsBrighton");
    searchRecent("Boston:Jamaica Plain", 3, "recentListingsJP");
    
  }
}
</script>

<style lang="scss" scoped>

div{
  text-align: left;
}

.link-big{
  font-size: 1.5em;
  font-weight: normal;
  cursor: pointer;
  padding: 10px;
  padding-left: 40px;
  padding-right: 40px;
  margin: 10px;
  margin-top: 40px;
  background-color: mix(black, $color-primary, 30);
  //background-color: transparent;
  //color: $color-primary;
  display: inline-block;
  border-radius: 2px;
  transition: background-color .3s;
}

.top-margin-10{
  margin-top: 10px;
}

.link-big:hover{
  background-color: $color-accent;
}

#uprightMapFrame{
  width: 100%;
  height: 390px;
  margin: 0;
  padding: 0;
  border: none;
  flex-grow: 1;
  flex-basis: 390px;
  border-bottom: 1px solid $color-primary;
  border-top: 1px solid $color-primary;
  //box-shadow: 2px 2px 2px gray;
}

.full-width-accent{
  margin: 0;
  //width: 100vw;
  color: white;
  background-color: $color-primary-dark-40;
  text-align: center;
  background-image: radial-gradient(circle, $color-primary-dark-20, mix(black, $color-primary, 60));
  padding:20px;
  margin-top: 20px;
  margin-bottom: 0;
}


.flex-container{
  display: flex;
  margin: 0;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.flex-item{
  //box-shadow: 2px 2px 4px black;
  padding: 20px;
  //border-radius: 5px;
  margin: 30px;
  max-width: 400px;
  line-height: 1.4em;
  display: flex;
  flex-direction: column;
  align-self: stretch;
}

.flex-item p{
  flex: 1 0 auto;
}


.flex-item a{
  color: $color-accent;
  //display: block;
  //text-align: right;
  padding: 4px 7px;
  //padding-right: 40px;
  //text-decoration: underline;
  font-size: 1.2em;
  margin: 10px 10px 10px auto;
  border-radius: 3px;
  border: 2px solid $color-accent;
  cursor: pointer;
  transition: .3s;
}

.flex-item a:hover{
  background-color: mix(black, $color-accent, 30);
  transform: scale(1.1);
}

.full-width-accent h1{
  padding: 80px;
  padding-bottom: 30px;
  margin: 0;
  font-weight: 100;
  //text-shadow: 4px 4px 4px rgba(0, 0, 0, .6);
}

h1 span{
  font-size: 1.2em;
  color: $color-accent;
  font-style: oblique;
  //text-shadow: 0 0 45px $color-accent;
}

@media only screen and (max-width: 1180px) {
  .flex-container{
    flex-direction: column;
    margin: 0 auto;
    justify-content: center;
  }

  .flex-item{
    max-width: 800px;
    margin: auto;
    border-top: 1px solid $color-accent;
  }
}

a.simple-on-light{
  color: $color-primary;
  text-decoration: underline;
}
</style>


